var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRail = function SvgRail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "rail_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rail_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.809 6.703V5.496h-.911v-1.99h-1.207v1.99H10.17v-1.99H8.963v1.99h-.911v1.207h.91v1.751h-.91v1.207h.91v1.751h-.91v1.207h.91v1.751h-.91v1.207h.91v1.751h-.91v1.207h.91v1.99h1.208v-1.99h3.52v1.99h1.208v-1.99h.91v-1.207h-.91v-1.75h.91V14.37h-.91v-1.75h.91v-1.208h-.91v-1.75h.91V8.453h-.91v-1.75h.91Zm-2.12 10.626h-3.52v-1.75h3.52v1.75Zm0-2.958h-3.52v-1.75h3.52v1.75Zm0-2.958h-3.52v-1.75h3.52v1.75Zm0-2.958h-3.52v-1.75h3.52v1.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rail_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgRail as ReactComponent };